module.exports = __webpack_public_path__ + "img/mt.b7697465.svg";